export default __webpack_public_path__ + "static/media/NajjarDocWhite.f2889fc7.svg";